import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Container/Container.requests'
import {
    ContainerGeoLocation,
} from 'app/Apps/ContainerManagement/Containers/containers.types'

const useGetLastGeolocation = (
    serialNumber,
) => {
    return useRequest<ContainerGeoLocation>({
        key: RequestKeys.getContainerLastGeolocation,
        params: {
            serialNumber,
        },
        requestFunc: RequestFn.getEntity(requests.getLastGeolocation),
        enabled: Boolean(serialNumber),
    })
}

export default useGetLastGeolocation
